{
  "eyebrow": "Witamy",
  "title": "Witaj w Done-it, {{company}}.",
  "titleGeneric": "Witaj w Done-it.",
  "sub": "Twoja 30-dniowa próba {{plan}} jest aktywna. Trzy kolejne kroki.",
  "subGeneric": "Twoje konto jest aktywne. Trzy rzeczy do zrobienia dalej.",
  "next1": {
    "title": "Pobierz aplikację mobilną",
    "desc": "Wyślij zespołowi link instalacyjny SMS-em lub e-mailem.",
    "cta": "Wyślij link z zaproszeniem"
  },
  "next2": {
    "title": "Zaproś swój zespół",
    "desc": "Zaimportuj pracowników z CSV lub dodaj ich pojedynczo.",
    "cta": "Otwórz panel"
  },
  "next3": {
    "title": "Obejrzyj 4-minutowe wprowadzenie",
    "desc": "Zobacz, jak skonfigurować pierwszy projekt i lokalizacje.",
    "cta": "Obejrzyj wideo"
  },
  "cta": "Przejdź do panelu",
  "receipt": "Potwierdzenie i e-mail powitalny zmierzają do {{email}}.",
  "receiptGeneric": "Potwierdzenie i e-mail powitalny są w drodze.",
  "fallbacks": {
    "company": "Twoja firma",
    "plan": "Twój plan",
    "inbox": "Twoja skrzynka"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Twoje konto {{plan}} jest aktywne — darmowe na zawsze. Trzy rzeczy do zrobienia dalej."
}
